import React,{ useMemo,useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import {
  useCreateFavoriteMutation,
  useDeleteFavoriteMutation,
  useGetAllFavoritesQuery
} from "../../services/modulesuser/favorite";
import { setFavorites } from "../../store/user";
import { HeartIcon } from "@heroicons/react/24/solid";
import { ModalProvider } from "../../store/context/ModalContext.js";
import { BASE_GAP_CLASS } from "../../services/lib/constants.js";
import TrailerButton from "../../component/ui/TrailerButton.js";
import Button from "../../component/ui/Button.js";
import { getEmbeddableUrl } from "../../services/utils/getEmbeddableUrl.js";

function MediaButtons({ media }) {
  const dispatch = useDispatch();

  const storedFavorites = useSelector(state => state.user.favorites);

  const { data: favoritesData = {},refetch,isLoading } = useGetAllFavoritesQuery();


  const fetchedFavorites = Array.isArray(favoritesData?.data?.result)
    ? favoritesData.data.result
    : [];

  const favorites = !isLoading && fetchedFavorites.length > 0
    ? fetchedFavorites
    : storedFavorites;


  useEffect(() => {
    const videos = (() => {
      const result = fetchedFavorites;
      if (Array.isArray(result)) {
        return result.map((video) => ({
          id: video.videoId,
          title: video.video.title,
          thumbnail: video.video.thumbnail,
          rating: video.video.rating || 0,
          url: video.video.url,
          description: video.video.description,
          createdAt: video.video.createdAt,
          categories: Array.isArray(video.video.categories) ? video.video.categories : [],
        }));
      }
      return [];
    })();
    if (!isLoading && Array.isArray(fetchedFavorites)) {
      dispatch(setFavorites(videos));
    }
  },[dispatch,fetchedFavorites,isLoading]);


  const isLiked = Array.isArray(favorites)
    ? favorites.some(fav => fav.videoId === media.id)
    : false;

  const [createFavorite,{ isLoading: isAdding }] = useCreateFavoriteMutation();
  const [deleteFavorite,{ isLoading: isRemoving }] = useDeleteFavoriteMutation();

  const embeddableVideoUrl = useMemo(
    () => getEmbeddableUrl(media?.trailerUrl || media?.url || ""),
    [media]
  );

  const handleFavoriteClick = async () => {
    try {
      if (isLiked) {
        await deleteFavorite({ videoId: media.id }).unwrap();
      } else {
        await createFavorite({ videoId: media.id }).unwrap();
      }
      refetch();
    } catch (err) {
      console.error("Errore gestione preferito:",err);
    }
  };

  return (
    <div className={`flex ${BASE_GAP_CLASS} gap-y-4 flex-wrap`}>
      <ModalProvider>
        <TrailerButton
          video={embeddableVideoUrl}
          videoId={media.id}
        />
      </ModalProvider>
      <Button
        onClick={handleFavoriteClick}
        disabled={isAdding || isRemoving || isLoading}
        label={isLiked ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
      >
        <span>
          <HeartIcon className={`w-8 inline-block pb-1 mr-2 ${isLiked ? "text-red-500" : "text-white-500"}`} />
          {isLiked ? "Rimuovi dai" : "Aggiungi ai"} preferiti
        </span>
      </Button>
    </div>
  );
}

export default MediaButtons;
